import { Injectable } from '@angular/core';
import {NbComponentStatus, NbDialogService, NbToastrService} from "@nebular/theme";
import {TranslateService} from "@ngx-translate/core";
import {ConfirmDialogComponent} from "../dialogs/confirm-dialog/confirm-dialog.component";

@Injectable({
  providedIn: 'root'
})
export class NotifierService {

  constructor(private dialog: NbDialogService,
              private translate: TranslateService,
              private toast: NbToastrService) {

  }

  public async notify(text: string, title: string = null, type:'show'|'default'|'warning'|'danger'|'info'|'primary'|'success' = 'default', icon = null, duration = 3500, inter = null){
    const info = await this.translate.get([text, title || 'success'], inter).toPromise();
    return this.toast[type](info[text], title ? info[title] : null, {
      icon: icon,
      duration: duration,
      preventDuplicates: true
    });
  }

  public async confirm(title: string, subtitle:string = null, yestitle: string = 'yes', status: NbComponentStatus = 'primary', notitle: string = 'no'){
    const did: boolean = await this.dialog.open<ConfirmDialogComponent>(ConfirmDialogComponent, {
      context: {
        title,
        subtitle,
        yestitle,
        status,
        notitle
      }
    }).onClose.toPromise();
    return did;
  }
}
